<template>
  <div>
    <a-modal :visible="modalVisible" :closable="false" :width="1000" @cancel="closeModal">
      <a-table :scroll="{ x: 1000 }" :columns="columns" size="middle" :data-source="taskList" :loading="loading" row-key="id">
        <span slot="customKey" slot-scope="text, record">
          <a @click="toDetail(record.source)">{{ '工单id：' + record.source }}</a>
        </span>
        <span slot="spendTime" slot-scope="text, record">
          {{ (record.spendTime / 3600).toFixed(2) + '小时' }}
        </span>
        <span slot="operationTime" slot-scope="text, record">
          {{ record.operationTime }}
        </span>
      </a-table>
      <div slot="footer" />
    </a-modal>
    <ticket-drawer v-if="editVisible" :visible="editVisible" :ticket-id="ticketId" @close="close" />
  </div>
</template>

<script>
import { problemUrgencys, problemStatus, ticketStatus, problemChannels, ticketDomain, ticketLevel, ticektTag, qiyuTicketStatus } from '@/utils/dictionary';
import TicketDrawer from '@/pages/event/components/TicketDrawer';
import { taskStatus } from '@/utils/dictionary';
export default {
  components: { TicketDrawer },
  props: {
    taskList: {
      type: Array,
      default: null
    }
  },

  data() {
    return {
      editVisible: false,
      modalVisible: false,
      ticketId: 0,
      loading: false,
      taskStatus,
      ticketStatus,
      problemChannels,
      problemUrgencys,
      qiyuTicketStatus,
      ticketDomain,
      ticketLevel,
      columns: [
        {
          title: 'ID',
          dataIndex: 'source',
          key: 'source',
          width: 70,
          scopedSlots: { customRender: 'customKey' }
        },
        {
          title: '操作时长',
          width: 150,
          dataIndex: 'spendTime',
          key: 'spendTime',
          scopedSlots: { customRender: 'spendTime' }
        },
        {
          title: '操作时间',
          width: 150,
          dataIndex: 'operationTime',
          key: 'operationTime',
          scopedSlots: { customRender: 'operationTime' }
        },
        {
          title: '操作人',
          width: 100,
          dataIndex: 'userName',
          key: 'userName',
          scopedSlots: { customRender: 'userName' }
        }
      ]
    };
  },
  computed: {
    link() {
      return record => {
        return record && record.project && record.taskId ? this.$router.resolve({ name: 'page:project:task:detail', query: { taskId: record.taskId }, params: { project_id: record.project }}).href : '';
      };
    }
  },
  methods: {
    // 获取任务列表
    getTodoList() {
      this.modalVisible = true;
    },
    closeModal() {
      this.modalVisible = false;
    },
    close() {
      this.editVisible = false;
    },
    toDetail(ticketId) {
      this.ticketId = ticketId;
      this.editVisible = true;
    },
    open() {
      this.modalVisible = true;
    },

    onViewFault(record) {
      const route = this.$router.resolve({ name: 'page:event:ticket:detail', query: { ticketId: record.id }});
      return route.href;
    }
  }
};
</script>

<style scoped>
.purple {
  background-color: rgba(128, 50, 150, 0.5);
  color: white;
  border-radius: 6px;
}

.orange {
  background-color: orange;
  color: white;
  border-radius: 6px;
}

.purple-orange {
  background: linear-gradient(to right, rgba(128, 50, 150, 0.5) 50%, orange 50%);
  color: white;
  border-radius: 6px;
}
</style>
